import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSubscript: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconSubscript"><Path d="M21.25 20.25H16.75C16.75 17.75 21.25 17.4352 21.25 14.9459C21.25 13.6227 20.2485 12.75 19.0058 12.75C17.9336 12.75 17.1989 13.3949 16.9025 14.2455" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/><Path d="M2.75 5.75L13.25 18.25M13.25 5.75L2.75 18.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconSubscript;
